export default function(d) {
  return d;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/identity.js
// module id = 905
// module chunks = 0